import { Link, graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { CallToActionButton } from "../CallToActionButton";

// add social icons

export const Menu = () => {
  const data = useStaticQuery(graphql`
    query MainMenuQuery {
      wp {
        mainMenu {
          mainMenu {
            callToActionButton {
              destination {
                ... on WpPage {
                  uri
                }
              }
              label
            }
            menuItems {
              root {
                destination {
                  ... on WpPage {
                    uri
                  }
                }
                label
              }
              subMenuItems {
                destination {
                  ... on WpPage {
                    uri
                  }
                }
                label
              }
            }
          }
        }
      }
    }
  `);

  const { menuItems } = data.wp.mainMenu.mainMenu;
  return (
    <div className="bg-color-white sticky top-0 z-20 font-bold text-color-primary xl:h-[70px] pt-[10px] px-3 overflow-hidden">
      <div className="innerMenu w-full xl:h-[50px] flex flex-nowrap justify-between items-center">
        <div>
          <Link to="/" className="flex font-bold no-underline xl:gap-3 items-center">
            <StaticImage
              src="../../../static/icon.png"
              layout="fixed"
              height={30}
              alt="Logo"
            />
            <span className="hidden sm:inline-block pl-2 xl:text-[15px]">Dan Branda for Westchester County Legislator</span>
          </Link>
        </div>
        <div className="block lg:grid lg:grid-cols-7 lg:grid-rows-1 lg:gap-x-[30px]">
          <div className="hidden lg:col-start-1 lg:block lg:col-span-5">
            <div className="flex flex-nowrap justify-end text-right items-center h-full">
              {(menuItems || []).map((menuItem, index) => (
                <div
                  key={index}
                  className="group relative flex h-full cursor-pointer nav-menu-link"
                >
                  <Link
                    to={menuItem.root.destination.uri}
                    className="flex h-full items-center text-color-black no-underline text-xs font-normal pl-[30px] nav-menu-link--item relative"
                  >
                    {menuItem.root.label}
                  </Link>
                  {!!menuItem.subMenuItems?.length && (
                    <div className="absolute top-full right-0 hidden bg-color-primary-light text-right group-hover:block">
                      {menuItem.subMenuItems.map((subMenuItem, index) => (
                        <Link
                          to={subMenuItem.destination.uri}
                          key={index}
                          className="block whitespace-nowrap p-4 text-color-white no-underline hover:bg-color-secondary"
                        >
                          {subMenuItem.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="w-[140px] lg:w-auto lg:col-start-6 lg:col-span-2">
            <CallToActionButton
              label={data.wp.mainMenu.mainMenu.callToActionButton.label}
              destination={
                data.wp.mainMenu.mainMenu.callToActionButton.destination.uri
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
